import { CookieAcceptedActionTypes } from "../models";
import { SET_COOKIE_ACCEPTED } from "../types";

export default (cookieAccepted = false, action: CookieAcceptedActionTypes): boolean => {
    const { payload } = action;
    switch (action.type) {
        case SET_COOKIE_ACCEPTED:
            return payload;
        default:
            return cookieAccepted;
    }
};
